import Vue from 'vue'
import WebTest from "@/pages/Test.vue";
import vueCustomElement from 'vue-custom-element'

import 'assets/scss/theme/bootstrap.scss'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'assets/scss/theme/custom.scss'

import bootstrapVue from 'bootstrap-vue'
Vue.use(bootstrapVue)

Vue.config.productionTip = false
Vue.use(vueCustomElement);
Vue.customElement('web-programa', (new WebTest()).$options);
